import { useTranslation } from 'react-i18next';
import React from 'react'
// ANTD
import { Col, Row } from 'antd'
import { DetailsContainer } from 'Components/shared/details-container';

const PaymentDetails = ({
    driverDetails,
}) => {

    const { t } = useTranslation();
    const paymentInfo = [
        {
            label:t("label.bankType"),
            value:driverDetails?.bankType
        },
        {
            label:t("label.accountNo"),
            value:driverDetails?.accountNo
        },
        {
            label:t("label.socsoNo"),
            value:driverDetails?.socsoNo
        },
        {
            label:t("label.epfNo"),
            value:driverDetails?.epfNo
        },
        {
            label:t("label.incomeTax"),
            value:driverDetails?.incomeTax
        },
        {
            label:t("label.hrdfNo"),
            value:driverDetails?.hrdfNo
        },
        {
            label:t("label.zakatNo"),
            value:driverDetails?.zakatNo
        },
    ]

    return (
        <>
            <DetailsContainer 
                listOfData={paymentInfo}
            />
        </>
    )
}

export default PaymentDetails